export interface Article {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  views: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '娱乐八卦', slug: 'entertainment' },
  { name: '网红主播', slug: 'influencer' },
  { name: '明星恋情', slug: 'romance' },
  { name: '社会热点', slug: 'social' },
  { name: '影视综艺', slug: 'tvshow' },
  { name: '搞笑趣闻', slug: 'funny' },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子 酒店共度8小时引热议',
    slug: 'top-star-secret-date',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    excerpt: '据知情人士透露，该男星近日在横店拍戏期间，被拍到与一名神秘女子深夜返回酒店，两人全程保持距离但被目击先后进入同一房间，至次日清晨才先后离开。粉丝纷纷炸锅，工作室至今未回应。',
    content: `<p>近日，有八卦媒体拍到某当红男星在横店拍戏期间，深夜与一名神秘女子约会。据拍摄画面显示，当晚11点左右，该男星结束拍摄后，乘坐保姆车返回下榻酒店。大约半小时后，一名身穿黑色连衣裙的神秘女子出现在酒店大堂，随后被男星的助理带往房间。</p>
<p>据悉，该女子在男星房间内待到次日早上7点左右才离开。期间，男星的助理曾多次进出房间送餐。有酒店工作人员透露，该女子并非剧组人员，而是通过助理引荐前来的。</p>
<p>消息一出，立即引发网友热议。有粉丝表示"等待官方回应"，也有吃瓜群众调侃"又到了熟悉的节奏"。截至目前，该男星的工作室尚未就此事发表任何声明。</p>
<p>业内人士分析称，该男星目前正值事业上升期，若恋情属实可能会对其商业价值产生影响。但也有观点认为，正常恋爱无可厚非，关键看团队如何公关。</p>
<p>相关话题迅速登上热搜榜首位，阅读量在短短两小时内突破2亿。不少营销号开始深挖该女子身份，有网友扒出疑似某网红的小号曾发布过与该男星同款酒店的照片。</p>`,
    image: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20luxury%20hotel%20corridor%20at%20night%20with%20warm%20golden%20lighting%2C%20two%20silhouettes%20walking%20separately%20towards%20a%20hotel%20room%20door%2C%20cinematic%20moody%20atmosphere%2C%20subtle%20drama%2C%20editorial%20style%2C%20soft%20focus%2C%20high%20contrast%2C%20warm%20amber%20tones%2C%20luxury%20interior%20details&width=800&height=500&seq=article-01&orientation=landscape',
    date: '2026-08-04',
    views: 1256800,
    tags: ['顶流男星', '恋情曝光', '酒店密会', '娱乐圈'],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '某女团成员被爆与公司解约纠纷 三年合约暗藏玄机',
    slug: 'girl-group-contract-dispute',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    excerpt: '当红女团成员小A近日向法院提起诉讼，要求与经纪公司解除合约。据透露，合约中存在多项不合理条款，包括收入分成比例严重失衡、活动安排过密导致健康受损等。',
    content: `<p>当红女团成员小A（化名）近日向法院提交诉讼，要求与所属经纪公司解除专属合约。据了解，双方合约已执行三年，但小A方面认为合同中存在多项不合理条款。</p>
<p>据小A代理律师透露，主要争议焦点包括：收入分成比例严重失衡（公司占比高达85%）、未经本人同意的商业活动安排、以及过度密集的行程导致艺人身心健康受损等。律师表示已收集了大量证据，包括医疗记录和财务文件。</p>
<p>经纪公司则发表声明称，严格遵守了合约规定，并表示小A的指控"与事实不符"。公司方表示愿意通过协商解决问题，但若协商失败也将采取法律手段维护自身权益。</p>
<p>此事在粉丝圈引发巨大反响。多位粉丝后援会联合发声，表示支持小A维权，并呼吁行业关注艺人的合法权益。有业内人士指出，近年来类似的合约纠纷并不少见，反映了娱乐行业经纪模式的待完善之处。</p>
<p>法律专家分析，此类案件的关键在于合约条款是否构成显失公平，以及公司是否存在违约行为。若法院认定合约无效，小A有望获得自由身，但可能需要支付一定的违约金。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20courtroom%20scene%20with%20a%20young%20female%20idol%20seated%20at%20a%20table%20with%20legal%20documents%20spread%20out%2C%20soft%20natural%20light%20streaming%20through%20windows%2C%20serious%20atmosphere%2C%20editorial%20photography%20style%2C%20neutral%20warm%20tones%2C%20clean%20composition&width=800&height=500&seq=article-02&orientation=landscape',
    date: '2026-08-03',
    views: 892300,
    tags: ['女团', '合约纠纷', '经纪公司', '艺人权益'],
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: '知名主播直播翻车 误开美颜滤镜暴露真实颜值',
    slug: 'streamer-makeup-filter-fail',
    category: '网红主播',
    categorySlug: 'influencer',
    excerpt: '拥有千万粉丝的某知名女主播在昨晚直播时，因设备故障导致美颜滤镜意外关闭，真实容貌与平时直播画面差距巨大，弹幕瞬间炸裂。该主播紧急下线回避，引发网友热议。',
    content: `<p>昨晚，某平台拥有超过千万粉丝的知名女主播在进行日常直播时，遭遇了职业生涯中最尴尬的一幕。直播进行到一半时，设备突然出现故障，美颜滤镜意外关闭了大约30秒。</p>
<p>滤镜关闭的30秒内，直播间的观众看到了主播未经修饰的真实容貌，与平时精致完美的形象形成了鲜明对比。弹幕瞬间炸裂，各种评论纷至沓来。有网友表示震惊"完全认不出来了"，也有人表示理解"美颜本来就是正常的"。</p>
<p>发现异常后，该主播迅速关闭了直播，并在半小时后发布了一条动态解释称"设备出了点问题，明天修好了继续播"。但该动态下依然涌入了大量评论。</p>
<p>此事引发了关于"网络真实性"的广泛讨论。支持者认为直播美颜是行业常态，无可厚非；批评者则指出过度P图已经形成了一种欺骗。有心理学专家表示，过度依赖美颜滤镜可能导致社交焦虑和容貌焦虑。</p>
<p>值得注意的是，该主播的粉丝数量在事件发生后不降反升，不少新粉丝表示"反而觉得更真实了"。业内人士分析称，这或许意味着网友对网红的审美正在发生变化，真实性正在成为新的流量密码。</p>`,
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20streaming%20studio%20setup%20with%20ring%20light%20and%20camera%20facing%20an%20empty%20chair%2C%20computer%20screen%20showing%20glitchy%20interface%2C%20warm%20ambient%20lighting%2C%20tech%20malfunction%20vibe%2C%20editorial%20style%2C%20clean%20modern%20room%20with%20pink%20accent%20wall&width=800&height=500&seq=article-03&orientation=landscape',
    date: '2026-08-03',
    views: 2150000,
    tags: ['网红主播', '直播翻车', '美颜滤镜', '颜值争议'],
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '某知名演员被曝隐婚生子 妻子竟是圈外人',
    slug: 'actor-secret-marriage',
    category: '明星恋情',
    categorySlug: 'romance',
    excerpt: '近日有媒体拍到某知名男演员一家三口出行的画面，引发外界对其婚姻状况的猜测。经多方证实，该演员早在三年前就已低调完婚，妻子是圈外人士，目前已育有一子。',
    content: `<p>近日，某知名男演员被拍到与一名女子和一名幼童共同出行，画面温馨和睦。经过多方证实，该演员实际上早在三年前就已经低调完婚，妻子是圈外人士，两人育有一个可爱的儿子。</p>
<p>据知情人士透露，该演员为了保护家人隐私，一直未对外公开婚讯。妻子是一名普通的公司职员，两人经朋友介绍认识，交往两年后登记结婚。婚后的生活十分低调，妻子从不参与任何娱乐圈活动。</p>
<p>消息曝光后，大多数粉丝表示了理解和祝福。"他一直是个很注重隐私的人，能理解他的选择"，"祝福！希望他们一家幸福"。但也有部分粉丝感到被欺骗，表示"隐瞒那么久有点过分"。</p>
<p>娱乐圈隐婚并非个例。近年来，多位明星在婚后选择低调处理，有的甚至等到孩子出生后才公开。业内普遍认为，这反映了艺人对于家庭隐私权的重视，也与社会对明星私生活的过度关注有关。</p>
<p>该演员的工作室随后发布了简短的声明，确认了婚讯并感谢大家的关心与祝福，同时也呼吁媒体和网友尊重其家人的隐私。</p>`,
    image: 'https://readdy.ai/api/search-image?query=A%20happy%20family%20of%20three%20walking%20in%20a%20sunlit%20park%2C%20father%20holding%20a%20toddlers%20hand%2C%20mother%20smiling%20warmly%2C%20soft%20natural%20light%2C%20warm%20golden%20hour%20glow%2C%20editorial%20portrait%20photography%2C%20peaceful%20atmosphere%2C%20blurred%20greenery%20background&width=800&height=500&seq=article-04&orientation=landscape',
    date: '2026-08-02',
    views: 1980500,
    tags: ['隐婚', '明星恋情', '圈外人', '家庭'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '某综艺节目录制现场发生意外 选手受伤被紧急送医',
    slug: 'variety-show-accident',
    category: '影视综艺',
    categorySlug: 'tvshow',
    excerpt: '正在录制的某热门综艺节目昨日发生意外，一名参赛选手在完成高难度挑战时不幸受伤，被紧急送往医院治疗。节目组已暂停录制并发布致歉声明。',
    content: `<p>昨日下午，正在如火如荼录制的某热门竞技类综艺节目突发意外。据悉，一名参赛选手在执行高空挑战任务时，因安全绳索出现松动，从约3米高的位置坠落，造成腿部和手臂多处受伤。</p>
<p>事故发生后，现场医护人员立即进行了紧急处理，随后该选手被救护车送往附近的三甲医院进行治疗。据医院方面透露，选手目前情况稳定，没有生命危险，但需要住院观察一段时间。</p>
<p>节目组在事发两小时后发布官方声明，向受伤选手及其家人诚恳致歉，并表示将承担全部医疗费用。同时，节目组宣布暂停录制，全面排查安全隐患，确保所有安全设备和操作流程符合标准。</p>
<p>此事引发了观众对综艺节目安全保障的广泛关注。有网友翻出该节目此前也出现过类似的安全隐患，质疑节目组为了追求视觉效果而忽视了参与者的人身安全。</p>
<p>广电相关部门已介入调查，要求节目组提交详细的事故报告和安全整改方案。业内人士表示，这起事件可能会推动整个行业加强对综艺录制安全的监管力度。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20bright%20stage%20lights%20and%20obstacle%20course%20equipment%2C%20emergency%20medical%20team%20visible%20in%20background%2C%20dramatic%20lighting%2C%20behind%20the%20scenes%20production%20atmosphere%2C%20editorial%20style%2C%20warm%20studio%20lighting&width=800&height=500&seq=article-05&orientation=landscape',
    date: '2026-08-02',
    views: 1560200,
    tags: ['综艺意外', '选手受伤', '安全隐患', '节目组'],
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: '外卖小哥雨中送餐感动全网 获平台百万奖励',
    slug: 'delivery-rider-rain-story',
    category: '社会热点',
    categorySlug: 'social',
    excerpt: '一段外卖小哥在暴雨中蹚水送餐的视频近日走红网络。视频中，小哥宁可自己淋湿也要保护餐品不受潮，最终准时送达。平台方宣布给予其百万奖励并授予"年度优秀骑手"称号。',
    content: `<p>近日，一段拍摄于暴雨中的短视频在各大社交平台疯传。视频中，一名外卖骑手在齐膝深的积水中艰难前行，将雨衣披在外卖箱上，自己却浑身湿透。最终，他准时将餐品送到了顾客手中。</p>
<p>据悉，事情发生在上周五的一场暴雨中。当天下午突降暴雨，多个路段出现积水。这位外卖小哥为了不让餐品受潮，将自己的雨衣脱下来盖在外卖箱上，自己在暴雨中蹚水前行了近二十分钟。</p>
<p>拍摄视频的顾客表示，当时看到小哥的样子非常感动，"他全身都湿透了，但是餐品完好无损，而且只迟到了三分钟"。顾客将视频发布到网上后，迅速获得了千万级别的播放量。</p>
<p>外卖平台在获悉此事后，第一时间联系了这位骑手。平台宣布给予其100万元的专项奖励，并授予"年度优秀骑手"称号。平台发言人表示："他的敬业精神代表了千千万万外卖骑手的职业态度，值得我们所有人的尊重。"</p>
<p>然而，也有观点认为，与其给予高额奖励个案，不如从根本上改善骑手的工作条件和保障制度。有社会学专家呼吁平台建立更完善的恶劣天气配送补贴机制，让每一个骑手都能得到应有的保障。</p>`,
    image: 'https://readdy.ai/api/search-image?query=A%20delivery%20rider%20in%20heavy%20rain%20walking%20through%20flooded%20city%20street%2C%20wearing%20a%20yellow%20uniform%2C%20carrying%20a%20food%20delivery%20bag%2C%20dramatic%20rainy%20atmosphere%2C%20cinematic%20lighting%2C%20urban%20landscape%2C%20emotional%20documentary%20style%2C%20warm%20tones%20despite%20rain&width=800&height=500&seq=article-06&orientation=landscape',
    date: '2026-08-01',
    views: 3890200,
    tags: ['外卖小哥', '暴雨送餐', '感动全网', '正能量'],
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    title: '某喜剧演员直播带货翻车 口误引发品牌方不满',
    slug: 'comedian-livestream-bloopers',
    category: '搞笑趣闻',
    categorySlug: 'funny',
    excerpt: '知名喜剧演员老张昨晚首次尝试直播带货，不料因紧张频频口误，将品牌名称说错三次，甚至把"高端护肤"说成了"高端糊饼"。品牌方当场黑脸，直播间观众却笑翻。',
    content: `<p>知名喜剧演员老张昨晚开启了自己的直播带货首秀，本来品牌方期望凭借其国民度带来一波销量高峰，然而事情的发展却出乎所有人的意料。</p>
<p>直播开始不到五分钟，老张就因为紧张将品牌名称"雅诗兰黛"说成了"雅思蓝带"，引发弹幕一片"哈哈哈"。品牌方代表在一旁的笑容已经有些勉强。更尴尬的是，当介绍一款高端护肤精华时，老张口误将"高端护肤"说成了"高端糊饼"，直播间弹幕瞬间炸裂。</p>
<p>品牌方代表当场黑脸，试图纠正老张，但老张似乎越紧张越出错，又在接下来的介绍中将产品的核心成分"玻尿酸"说成了"玻璃酸"。品牌方最终无奈地提前结束了直播环节。</p>
<p>然而，这场翻车直播反而带来了意想不到的效果。相关片段被剪辑后在各大平台疯传，播放量迅速破亿。网友们纷纷评论"笑死我了""这才是真正的喜剧人""品牌方赚大了，这波流量比正常直播大多了"。</p>
<p>事后，老张发博自嘲称："对不起品牌方，我不适合带货，我还是适合说相声。"品牌方也幽默回应："感谢老张的'反向带货'，我们的产品已经被问爆了。"这次翻车意外成了双赢的经典案例。</p>`,
    image: 'https://readdy.ai/api/search-image?query=A%20comedian%20sitting%20at%20a%20livestream%20desk%20with%20skincare%20products%20displayed%2C%20looking%20flustered%20and%20funny%20expression%2C%20bright%20studio%20ring%20light%2C%20colorful%20background%2C%20humorous%20editorial%20style%2C%20warm%20lighting&width=800&height=500&seq=article-07&orientation=landscape',
    date: '2026-08-01',
    views: 2678000,
    tags: ['直播带货', '喜剧演员', '口误翻车', '搞笑'],
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: '某短视频平台网红被指内容抄袭 多段视频与原作神似',
    slug: 'influencer-content-plagiarism',
    category: '网红主播',
    categorySlug: 'influencer',
    excerpt: '拥有五百万粉丝的某短视频网红近日被多名创作者联合指控内容抄袭。对比视频显示，其多段视频的创意、运镜、甚至台词都与其他创作者的作品高度相似。',
    content: `<p>近日，多名短视频创作者联合发声，指控某拥有五百万粉丝的头部网红长期抄袭他们的原创内容。被指控的网红以搞笑短剧走红，但多位原创作者晒出对比视频，指出多段视频在创意、运镜、台词等方面与原作高度相似。</p>
<p>最早发声的是一位仅有几万粉丝的小创作者。他晒出的对比视频显示，该网红的某条爆款视频与其半年前发布的作品几乎一模一样，从开场的运镜方式到中间的转折设计都如出一辙。该创作者表示："我花了一周时间构思和拍摄，他直接拿去用，连改都不带改的。"</p>
<p>随后，又有三位创作者加入控诉行列，纷纷贴出对比证据。面对指控，该网红最初保持沉默，但在舆论压力下，最终发布了一段道歉视频。他表示"部分内容确实参考了其他创作者的作品，但并非有意抄袭，会在后续创作中更加注意"。</p>
<p>然而，这个道歉并未平息争议。不少网友认为其道歉态度敷衍，没有具体说明哪些内容是参考的，也没有向被抄袭的创作者道歉。有法律人士分析，短视频内容的版权界定确实存在灰色地带，但明显的相似创作可以构成侵权。</p>
<p>平台方也已介入调查，表示如果确认存在抄袭行为，将按照平台规则进行处理。此事再次引发了关于短视频内容创作版权保护的行业讨论。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20of%20two%20similar%20short%20video%20scenes%2C%20social%20media%20content%20creation%20setup%20with%20smartphone%20on%20tripod%2C%20modern%20studio%20lighting%2C%20editorial%20style%2C%20clean%20background%2C%20warm%20neutral%20tones&width=800&height=500&seq=article-08&orientation=landscape',
    date: '2026-07-31',
    views: 1324000,
    tags: ['网红', '内容抄袭', '短视频', '版权争议'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: '某影视剧拍摄现场路透流出 主角造型引网友吐槽',
    slug: 'drama-set-leaked-photos',
    category: '影视综艺',
    categorySlug: 'tvshow',
    excerpt: '备受期待的某古装大剧近日流出一组拍摄路透照，女主角的造型成为网友热议焦点。不少人吐槽服装设计过于"接地气"，与原著描述差距较大，甚至有网友P图恶搞。',
    content: `<p>备受期待的古装大剧《XXX》目前正在紧锣密鼓地拍摄中。然而，近日流出的路透照却让众多期待该剧的网友大跌眼镜，尤其是女主角的造型引发了广泛吐槽。</p>
<p>从路透照来看，女主角的服装采用了较为简约的设计风格，整体色调偏暗，配饰也相对简单。但问题在于，原著中对女主角的描写是"倾国倾城""华服锦簇"，而实际呈现的效果却与这个描述相去甚远。有网友毒舌评论："这造型看着像是去逛街，不是去上朝。"</p>
<p>吐槽大军迅速集结，各路P图高手开始发挥创意。有人将女主角的造型P进了各种搞笑场景，从菜市场买菜到公交车站等车，相关恶搞图在社交平台上疯传。话题"XX造型"迅速登上热搜。</p>
<p>面对铺天盖地的吐槽，该剧的造型指导在接受采访时表示，目前的造型只是剧中角色的日常装扮，并非正式场合的造型，希望大家耐心等待更多物料释出。同时他也承认会根据网友反馈进行适当调整。</p>
<p>制片方也表示，目前流出的路透照并非最终效果，正式播出时会有更好的呈现。但不少网友并不买账，认为连日常造型都不过关，很难让人对正片有信心。该剧的口碑在开播前就遭遇了滑铁卢。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20Chinese%20historical%20drama%20film%20set%2C%20actress%20in%20traditional%20costume%20standing%20next%20to%20cameras%20and%20crew%2C%20outdoor%20shooting%20location%20with%20ancient%20architecture%2C%20cinematic%20lighting%2C%20warm%20earthy%20tones&width=800&height=500&seq=article-09&orientation=landscape',
    date: '2026-07-31',
    views: 945000,
    tags: ['路透照', '造型吐槽', '古装剧', '网友恶搞'],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '某知名歌手演唱会假唱被实锤 粉丝后援会集体脱粉',
    slug: 'singer-lip-sync-scandal',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    excerpt: '近日有技术流网友通过音频分析，实锤某歌手在最近的巡演中大量使用预录音轨。证据确凿后，多个粉丝后援会宣布解散，该歌手形象遭受重创。',
    content: `<p>近日，一位自称音频工程师的网友发布了一条技术分析视频，用专业软件对比了某知名歌手最近三场演唱会的音频波形。分析结果显示，多首歌曲的声波几乎完全一致，这在真实演唱中是不可能的。</p>
<p>该视频发布后迅速引发关注。更多技术流网友加入分析行列，从不同角度验证了假唱的结论。有人甚至将演唱会音频与五年前发行的录音室版本进行比对，发现其中几首歌曲的音频完全吻合。</p>
<p>消息传开后，歌手的多个粉丝后援会内部爆发激烈争论。在等待一周未等到合理解释后，七个大型后援会先后宣布解散。有前粉丝会会长发文表示："支持了你八年，没想到你连给我们一场真实的演唱会都做不到。"</p>
<p>面对愈演愈烈的舆论，该歌手所属经纪公司发表声明，承认在部分高难度歌曲中使用了辅助音轨，但否认完全假唱。这个解释并未获得公众认可，反而被调侃为"辅助音轨"成为了新的网络梗。</p>
<p>业内人士分析，此次事件的严重性在于打破了粉丝对偶像的信任。演唱会作为艺人与粉丝最直接的互动方式，一旦被证实存在欺骗行为，修复信任将是一条漫长而艰难的道路。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20spotlights%20and%20microphone%20stand%2C%20large%20LED%20screen%20in%20background%2C%20dramatic%20lighting%2C%20empty%20arena%20seats%2C%20melancholic%20atmosphere%2C%20cinematic%20editorial%20style%2C%20cool%20warm%20contrast%20lighting&width=800&height=500&seq=article-10&orientation=landscape',
    date: '2026-07-30',
    views: 3100000,
    tags: ['演唱会假唱', '粉丝脱粉', '歌手', '实锤'],
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: '某高校食堂阿姨因高颜值走红 学生排长队只为看一眼',
    slug: 'cafeteria-lady-viral',
    category: '社会热点',
    categorySlug: 'social',
    excerpt: '近日某高校食堂一位年轻阿姨因颜值出众在校园内走红。学生拍下的照片在社交平台疯传，甚至有外校学生专程前来"打卡"，食堂窗口前每天都排起长队。',
    content: `<p>近日，在某高校的食堂里，一位年轻的女工作人员意外走红网络。事情的起因是一名学生在排队打饭时随手拍了一张照片发到校园论坛上，配文"我们食堂新来的阿姨也太好看了吧"。</p>
<p>照片迅速在校园内传播，随后被转发到微博等社交平台，引发了更大范围的关注。照片中的女工作人员大约二十多岁，五官精致，身穿白色工作服，戴着口罩仍难掩清秀气质。</p>
<p>走红之后，该食堂窗口前的队伍明显变长。不少学生特意选择这个窗口排队，只为近距离看一眼这位"食堂女神"。甚至有外校的学生专程赶来"打卡"，将照片发到朋友圈后被同学追问"这是哪个食堂"。</p>
<p>学校方面对此事保持开放态度，但也提醒学生文明就餐，不要影响到食堂的正常运转和其他用餐同学的体验。食堂经理表示，该员工是一名普通的食堂工作人员，希望大家能够理性看待，尊重她的工作和隐私。</p>
<p>当事人本人在接受校媒简短采访时表示，对于突然的关注有些不知所措，但感谢大家的善意，希望大家更多地关注食堂的饭菜质量。这段采访被发布后，网友们纷纷为她的谦逊点赞。</p>`,
    image: 'https://readdy.ai/api/search-image?query=University%20cafeteria%20interior%20with%20students%20lining%20up%20at%20a%20food%20counter%2C%20bright%20clean%20modern%20canteen%2C%20steaming%20food%20dishes%2C%20warm%20indoor%20lighting%2C%20editorial%20photography%20style%2C%20lively%20atmosphere%2C%20neutral%20warm%20tones&width=800&height=500&seq=article-11&orientation=landscape',
    date: '2026-07-29',
    views: 4230000,
    tags: ['高校食堂', '高颜值', '走红', '校园'],
    isHot: true,
    isNew: false,
  },
  {
    id: 12,
    title: '某明星被拍到深夜夜店狂欢 第二天却发微博说在健身',
    slug: 'celebrity-club-lie',
    category: '搞笑趣闻',
    categorySlug: 'funny',
    excerpt: '某明星前一天深夜被拍到在某知名夜店狂欢到凌晨三点，第二天上午却发了一条"早起健身打卡"的微博，配图疑似是库存旧照。网友火眼金睛戳穿谎言，评论区秒变大型翻车现场。',
    content: `<p>娱乐圈又出一个翻车名场面。某明星前天深夜被狗仔队拍到出现在某知名夜店，与一群朋友狂欢到凌晨三点才离开。照片中该明星面色微醺，手持酒杯，状态相当尽兴。</p>
<p>然而令人捧腹的是，第二天上午十点左右，该明星发布了一条微博："早起健身打卡！自律的人生不需要解释！"，配图是一张健身房的自拍。如果不看时间线，这条微博的确营造出了"自律阳光好青年"的人设。</p>
<p>然而吃瓜群众的眼睛是雪亮的。很快就有网友发现，这张健身房自拍与三个月前发布过的一张照片高度相似，从发型、穿搭到背景角度都一模一样，显然是一张库存旧照。更致命的是，有技术流网友通过照片的EXIF信息确认，拍摄时间确实是三个月前。</p>
<p>评论区瞬间变成大型翻车现场。"哥，你凌晨三点还在蹦迪，十点就健身打卡？时差倒过来了吗？""这张健身照已经用了三次了，换一张吧求求了""自律的人设崩了，但是喜剧人的人设立住了"——各种神评论让人忍俊不禁。</p>
<p>截至目前，该明星尚未对此事作出回应，但那条健身微博已经被悄悄删除。然而互联网是有记忆的，相关截图早已满天飞。网友戏称这是"2026年度最强翻车奖"的有力竞争者。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Gym%20interior%20with%20mirrors%20and%20equipment%2C%20a%20smartphone%20on%20a%20bench%20showing%20social%20media%20app%2C%20split%20with%20a%20nightclub%20scene%20showing%20colorful%20lights%20and%20crowd%2C%20editorial%20style%2C%20contrasting%20atmospheres%2C%20warm%20lighting&width=800&height=500&seq=article-12&orientation=landscape',
    date: '2026-07-28',
    views: 1890000,
    tags: ['明星', '夜店', '翻车', '人设崩塌'],
    isHot: false,
    isNew: false,
  },
];

export const getArticleById = (id: number): Article | undefined => {
  return articles.find((article) => article.id === id);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((article) => article.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  if (categorySlug === 'all') return articles;
  return articles.filter((article) => article.categorySlug === categorySlug);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((article) => article.isHot);
};

export const getLatestArticles = (limit?: number): Article[] => {
  const sorted = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  return limit ? sorted.slice(0, limit) : sorted;
};

export const getRelatedArticles = (currentId: number, limit: number = 4): Article[] => {
  const current = articles.find((a) => a.id === currentId);
  if (!current) return [];
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === current.categorySlug)
    .slice(0, limit);
};